import { queryOptions } from "@tanstack/react-query";
import { License } from "@/types/models";
import api, { ApiCatalog } from "@/api";

export const licensesQueries = {
  all: () => [ApiCatalog.license.key] as const,
  get: (uniqueId: string = "me") =>
    queryOptions({
      queryKey: [...licensesQueries.all(), uniqueId],
      queryFn: () =>
        api().get<License[]>(ApiCatalog.license.endpoint, {
          urlReplacers: [{ id: uniqueId }],
        }),
    }),
};
